import React, { useContext } from "react";
import { Card, Typography, Button } from "antd";
import { useHistory } from "react-router-dom";
import AppContext from "../../context/app.context";
import { IAppContext } from "../../interfaces/context.interfaces";
import { IFirebaseAuthUser } from "../../interfaces/authentication.interfaces";
import AuthenticationValidatorLogic from "../../logic/authenticationValidatorLogic";
import StatisticTable from "./StatisticTable";
import {
  sviStatisticRows,
  sviStatisticSummary,
} from "../../services/svidashboard.mock";
import * as ROUTES from "../../constants/routes";
import { isDreamUser as checkIsDreamUser } from "../../constants/dream.constants";
import withAuthorization from "../HOC/with.authorization";

const { Title, Paragraph } = Typography;

const StatisticsPage: React.FC = () => {
  const history = useHistory();
  const appContext: IAppContext = useContext(AppContext);
  const userEmail =
    appContext?.services?.firebaseService?.auth?.currentUser?.email ?? "";
  const isDreamUser = checkIsDreamUser(userEmail);

  return (
    <div style={{ padding: 24 }}>
      <Button
        style={{ marginBottom: 16 }}
        onClick={() => {
          if (history.length > 1) {
            history.goBack();
          } else {
            history.push("/");
          }
        }}
      >
        ← Back
      </Button>
      <Card>
        <Title level={3} style={{ fontWeight: 800 }}>
          General Statistics
        </Title>
        <Paragraph style={{ fontWeight: 600 }}>
          Overview of progress status per object and year. Click any row for a
          more detailed view.
        </Paragraph>
        <StatisticTable
          summary={sviStatisticSummary}
          rows={sviStatisticRows}
          normalWeightExpandedQuarterCells={isDreamUser}
          onRowClick={(row) =>
            history.push(
              ROUTES.OBJECT_STATS.route.replace(":objectId", row.objectId),
            )
          }
        />
      </Card>
    </div>
  );
};

const condition = (authUser: IFirebaseAuthUser) =>
  AuthenticationValidatorLogic.isDreamUser(authUser);

export default withAuthorization(condition)(ROUTES.MAP.route)(StatisticsPage);
